var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDealershipSettingsGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.794 7.62793H16.1407C15.6985 8.51235 15.1457 9.17567 14.4824 9.83898H17.0251L17.6884 13.1556H2.21106L2.87437 9.83898H5.41709C4.75377 9.17567 4.201 8.51235 3.75879 7.62793H1.10553L0 13.1556V15.3666H1.10553V21.9998H12.1608V15.3666H16.5829V21.9998H18.794V15.3666H19.8995V13.1556L18.794 7.62793ZM9.94975 19.7887H3.31658V15.3666H9.94975V19.7887Z",
    fill: "#6F7073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7081 4.97487C13.7081 4.75377 13.7081 4.53266 13.5975 4.31156L14.7031 3.31658L13.7081 1.54774L12.2709 1.98995C11.9392 1.76884 11.6076 1.54774 11.1654 1.32663L10.9443 0H8.95431L8.62265 1.43719C8.18044 1.54774 7.84878 1.76884 7.51712 2.1005L6.07994 1.65829L5.08496 3.31658L6.19049 4.31156C6.19049 4.53266 6.07994 4.75377 6.07994 4.97487C6.07994 5.19598 6.07994 5.41709 6.19049 5.63819L5.08496 6.63317L6.07994 8.40201L7.51712 7.9598C7.84878 8.1809 8.18044 8.40201 8.62265 8.62312L8.95431 9.94975H10.9443L11.2759 8.51256C11.7181 8.40201 12.0498 8.1809 12.3814 7.84925L13.8186 8.29146L14.8136 6.63317L13.7081 5.63819C13.7081 5.41709 13.7081 5.19598 13.7081 4.97487ZM9.94928 6.96482C8.84375 6.96482 7.95933 6.0804 7.95933 4.97487C7.95933 3.86935 8.84375 2.98492 9.94928 2.98492C11.0548 2.98492 11.9392 3.86935 11.9392 4.97487C11.9392 6.0804 11.0548 6.96482 9.94928 6.96482Z",
    fill: "#6F7073"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.8995,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealershipSettingsGray);
export default __webpack_public_path__ + "static/media/dealership-settings-gray.a5639088.svg";
export { ForwardRef as ReactComponent };